import React from 'react';
import { ReactFlowProvider } from 'reactflow';
import { EmailAutomationBuilderContainer } from '../containers/EmailAutomationBuilderContainer';

interface EmailAutomationBuilderPageProps {
  baseUri: string;
}

export const EmailAutomationBuilderPage: React.FC<EmailAutomationBuilderPageProps> = ({
  baseUri
}) => {
  return (
    <div className="h-screen bg-gray-50 flex flex-col">
      {/* Main Content - Automation Builder */}
      <div className="flex-1">
        <ReactFlowProvider>
          <EmailAutomationBuilderContainer baseUri={baseUri} />
        </ReactFlowProvider>
      </div>
    </div>
  );
};
